'use strict';

var React = require('react');

var SvgResetMinor = function SvgResetMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M17 9a1 1 0 0 1-1-1c0-.551-.448-1-1-1h-9.586l1.293 1.293a.999.999 0 1 1-1.414 1.414l-3-3a.999.999 0 0 1 0-1.414l3-3a.997.997 0 0 1 1.414 0 .999.999 0 0 1 0 1.414l-1.293 1.293h9.586c1.654 0 3 1.346 3 3a1 1 0 0 1-1 1zm-14 2a1 1 0 0 1 1 1c0 .551.448 1 1 1h9.586l-1.293-1.293a.999.999 0 1 1 1.414-1.414l3 3a.999.999 0 0 1 0 1.414l-3 3a.999.999 0 1 1-1.414-1.414l1.293-1.293h-9.586c-1.654 0-3-1.346-3-3a1 1 0 0 1 1-1z"
  }));
};

exports.SvgResetMinor = SvgResetMinor;
